import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  NumberInput,
  NumberField,
  BooleanField,
  BooleanInput,
} from 'react-admin';

export const CategoryList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="uid" label="UID" />
      <TextField source="name" />
      <NumberField source="order" />
      <BooleanField source="enabled" />
    </Datagrid>
  </List>
);

export const CategoryEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="uid" label="UID" />
      <TextInput source="name" />
      <NumberInput source="order" />
      <TextInput source="description" multiline rows={5} />
      <BooleanInput source="enabled" />
    </SimpleForm>
  </Edit>
);

export const CategoryCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="uid" label="UID" required />
      <TextInput source="name" required />
      <NumberInput source="order" defaultValue={0} />
      <TextInput source="description" multiline rows={5} />
      <BooleanInput source="enabled" defaultValue={true} />
    </SimpleForm>
  </Create>
);

export const CategoryShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="uid" label="UID" />
      <TextField source="name" />
      <NumberField source="order" />
      <TextField source="description" />
      <BooleanField source="enabled" />
    </SimpleShowLayout>
  </Show>
);
